import { Colors } from '@src/colors';
import styled from 'styled-components';

export const ScrollButton = styled.div`
    width: 72px;

    & > svg {
        & > path {
            fill: ${Colors.white};
        }
    }
`;
